import { generateRepositoryMethods } from './repository.types.js';
export const insuranceRepositoryMethods = generateRepositoryMethods({
    getInsuranceList: {
        callMethod: 'GET',
        endpoint: '/insurance/list',
    },
    updateMediplusStatus: {
        callMethod: 'POST',
        endpoint: '/insurance/update-mediplus-status',
    },
});
//# sourceMappingURL=insurance.methods.js.map